import React from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  TableCell,
  Tooltip,
  IconButton,
  TableRow
} from '@material-ui/core';
import { format } from 'date-fns';
import { TextFormattedNumber } from 'components';
import { EditIcon } from 'components/CustomSVG';
import { convertUTCDateToLocalDate } from 'helpers/date';
import { giftCodeDeliveryMethods } from 'helpers/giftCards';
import { getSingleGiftCodeSuccess } from 'redux/actions/gift_card';


const GiftCodesTableRow = ({giftCodeData, headTableCells, labelId}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {profile} = useSelector((state: IReduxState) => state.user);
  const permissions = profile?.config?.permissions || {};

  const {
    giftcard_id,
    code,
    balance,
    status_label,
    delivery_method,
    created_at,
    customer_name,
    is_sent
  } = giftCodeData;

  const columns = headTableCells.reduce((acc, column) => {
    acc[column.label] = column;

    return acc;
  }, {});

  const createdAtdate = convertUTCDateToLocalDate(created_at);

  const handleEditGiftCode = () => {
    dispatch(getSingleGiftCodeSuccess(giftCodeData));
    history.push(`/gift-cards/${giftcard_id}`, { params: history.location.search });
  };

  return (
    <TableRow>
      {columns['Id']?.display &&
        <TableCell component="th" id={labelId} scope="row" padding="none">
          {giftcard_id}
        </TableCell>
      }
      {columns['Code']?.display &&
        <TableCell component="th" id={labelId} scope="row" padding="none">
          <Link className="text-primary underline" to={{pathname: `/gift-cards/${giftcard_id}`}}>
            {code}
          </Link>
        </TableCell>
      }
      {columns['Status']?.display &&
        <TableCell component="th" id={labelId} scope="row" padding="none">
          {status_label}
        </TableCell>
      }
      {columns['Balance']?.display &&
        <TableCell component="th" id={labelId} scope="row" padding="none">
          <TextFormattedNumber
            value={balance}
            prefix="$"
          />
        </TableCell>
      }
      {columns['Delivery']?.display &&
        <TableCell component="th" id={labelId} scope="row" padding="none">
          <div className={`${is_sent ? '' : 'text-error'}`}>
            {giftCodeDeliveryMethods[delivery_method]}
          </div>
        </TableCell>
      }
      {columns['Created Date']?.display &&
        <TableCell component="th" id={labelId} scope="row" padding="none">
          <div className="my-2">
            <div>{format(createdAtdate, 'MM/dd/yyyy')}</div>
            <div>{format(createdAtdate, 'hh:mm:ss aa')}</div>
          </div>
        </TableCell>
      }
      {columns['Customer']?.display &&
        <TableCell component="th" id={labelId} scope="row" padding="none">
          {customer_name}
        </TableCell>
      }
      {columns['Action']?.display &&
        <TableCell component="th" id={labelId} scope="row" padding="none">
          {permissions?.giftCardsEdit &&
          <Tooltip title="Edit">
            <IconButton
              onClick={handleEditGiftCode}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>}
        </TableCell>
      }
    </TableRow>
  );
};

export default GiftCodesTableRow;
